import { createSlice } from '@reduxjs/toolkit';

import type { SortearSubstitutoState } from '../../types/sortearSubstituto';
import { sortearSubstituto } from './actions';

const initialState: SortearSubstitutoState = {
  enviando: false,
  erro: null,
};

const sortearSubstitutoSlice = createSlice({
  name: 'secretariaArbitralSortearSubstituto',
  initialState,
  reducers: {
    /** Ao abrir o diálogo: a recusa da abertura anterior não vale para esta. */
    limparSortearSubstituto(state) {
      state.erro = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sortearSubstituto.pending, (state) => {
        state.enviando = true;
        state.erro = null;
      })
      .addCase(sortearSubstituto.fulfilled, (state) => {
        state.enviando = false;
      })
      // A corrida perdida (409) não tem texto: o diálogo fecha e a tela recarrega.
      .addCase(sortearSubstituto.rejected, (state, action) => {
        state.enviando = false;
        if (action.payload?.tipo === 'vaga_ja_preenchida') return;
        state.erro = action.payload?.mensagem ?? 'Erro ao sortear o árbitro substituto';
      });
  },
});

export const { limparSortearSubstituto } = sortearSubstitutoSlice.actions;
export const secretariaArbitralSortearSubstitutoReducer = sortearSubstitutoSlice.reducer;
